export const updateAddFilesUseCase = async ({
  getFreshToken,
  getEndpointUrl,
  files,
}) => {
  try {
    const freshToken = await getFreshToken();
    const response = await fetch(getEndpointUrl() + "/updateAddFiles", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${freshToken}`,
      },
      body: JSON.stringify({ files }),
    });

    if (!response.ok) throw new Error("Error updating or adding files.");

    console.log("Files updated or added successfully.");
    return response;
  } catch (error) {
    console.error("Error updating or adding files:", error);
    throw error;
  }
};
